export const footerList = [
  {
    merchantUuid: "8acda4c970cebc530170d3d163e22569",
    text:
      "As a valued member of the Harry Hall One Club, we regret to inform you that your recent payment has been declined by your card provider. Please can you promptly bring your account up to date by using the “register” button below to update your card details. If you prefer you can contact our customer services team on 01274 711011 and they will be happy to take your card details over the phone.",
  },
];

export const footerMap = new Map(
  footerList.map((f) => [f.merchantUuid, f.text])
);

// Define a function that takes a currency code and an array of currency objects, and returns the currency object that matches the code
export function findFooterByMerchantUuid(merchantUuid) {
  return footerMap.get(merchantUuid);
}
